/**
 * @fileoverview POST handler for the "/alloys/amazon-bedrock/agentic/:app_group_id/external_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysAmazonBedrockAgenticExternalIdCacheKeys } from "./constants";
import type {
  PostAlloysAmazonBedrockAgenticExternalIdProps,
  PostAlloysAmazonBedrockAgenticExternalIdResult,
} from "./types";

/**
 * Replaces the app group's pending Amazon Bedrock STS external ID with a new
 * one. A saved role-auth integration keeps its external ID until the next save.
 */
export const postAlloysAmazonBedrockAgenticExternalId = reactQueryMutationAdapter(
  postAlloysAmazonBedrockAgenticExternalIdCacheKeys,
  (
    props: PostAlloysAmazonBedrockAgenticExternalIdProps
  ): Promise<PostAlloysAmazonBedrockAgenticExternalIdResult> => {
    return fetch(`/alloys/amazon-bedrock/agentic/${props.appGroupId}/external_id`, "POST", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
